// extracted by mini-css-extract-plugin
module.exports = {"TextButton":"TextButton__TextButton___3swa3","hover":"TextButton__hover___2DIzs"};